<template>
	<Dialog :open="isModalOpen(props.id)" @close="handleClosed" class="relative z-[9999999]">
		<div class="fixed inset-0 bg-black/50" aria-hidden="true" />
		<div class="fixed inset-0 flex w-screen min-h-screen items-end md:items-center justify-center md:!p-4 ios-padding">
			<DialogPanel
				class="w-full max-w-sm md:max-w-3xl rounded-t-xl md:rounded-none bg-primary_alt grid grid-cols-1 md:grid-cols-2"
			>
				<div class="order-2 md:!order-1 !p-5 pb-safe flex flex-col items-center justify-center relative">
					<slot name="content-left" />
					<button
						v-if="showDismiss"
						type="button"
						aria-label="Close Dialog"
						class="absolute underline bottom-2 !p-1 left-1/2 -translate-x-1/2"
						@click="handleClosed"
					>
						Dismiss
					</button>
				</div>
				<div class="order-1 md:!order-2 relative rounded-t-xl md:rounded-none overflow-hidden">
					<button
						type="button"
						aria-label="Close Dialog"
						class="absolute z-10 bg-neutral-100/50 hover:bg-neutral-100 top-2 !p-1 rounded-full right-2"
						@click="handleClosed"
					>
						<svg-vue icon="close" class="w-4" />
					</button>
					<slot name="content-right" />
				</div>
			</DialogPanel>
		</div>
	</Dialog>
	<button v-if="showBtn" type="button" :class="btnClass" :aria-label="btnText" @click="() => setIsOpen(true)">
		{{ btnText }}
	</button>
</template>

<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { Dialog, DialogPanel } from '@headlessui/vue'

import { useModalStore } from '@stores'

const props = defineProps({
	autoShow: {
		type: Boolean,
		default: false,
	},
	id: {
		type: String,
		required: true,
	},
	showBtn: {
		type: Boolean,
		default: true,
	},
	btnText: {
		type: String,
		default: 'Learn More',
	},
	btnClass: {
		type: String,
		default: 'inline-block cursor-pointer font-normal underline text-xs/[14px]',
	},
	showDismiss: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['closed'])

const modalStore = useModalStore()
const { isModalOpen, hasModalFired } = storeToRefs(modalStore)
const { setModal, addToModalsFired, toggleModal, closeModal } = modalStore

onMounted(() => {
	if (props.autoShow && !hasModalFired.value(props.id)) {
		setModal(props.id, true)
		addToModalsFired(props.id)
	} else {
		setModal(props.id, false)
	}
})

const setIsOpen = (value) => toggleModal(props.id, value)

const handleClosed = () => {
	closeModal(props.id)
	emit('closed')
}

defineExpose({ setIsOpen })
</script>
